import { render, staticRenderFns } from "./MenuAssetMgmt.vue?vue&type=template&id=4e89d7c0&"
import script from "./MenuAssetMgmt.vue?vue&type=script&lang=js&"
export * from "./MenuAssetMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports